import { BarnestipendSatser } from './BarnestipendApi';

export const beregnStotte = (antallBarn: number, satser: BarnestipendSatser): number => {
    const antallBarnSats1 = Math.min(1, antallBarn);
    const antallBarnSats2 = Math.min(1, antallBarn - antallBarnSats1);
    const antallBarnSats3 = antallBarn - antallBarnSats1 - antallBarnSats2;

    return (
        antallBarnSats1 * satser.SATS_ST01_SFS31_BELOPSSATS_PER_BARN_TRINN1_PER_MND +
        antallBarnSats2 * satser.SATS_ST01_SFS31_BELOPSSATS_PER_BARN_TRINN2_PER_MND + 
        antallBarnSats3 * satser.SATS_ST01_SFS31_BELOPSSATS_PER_BARN_TRINN3_PER_MND
    );
};
